import { render } from "./AccountType.vue?vue&type=template&id=bed59de6&scoped=true"
import script from "./AccountType.vue?vue&type=script&lang=js"
export * from "./AccountType.vue?vue&type=script&lang=js"

import "./AccountType.vue?vue&type=style&index=0&id=bed59de6&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed59de6"]])

export default __exports__